import React from "react";

import { SupText } from "@repo/core-ui";

import AdapterLinkButton from "@/components/Adapter/LinkButton";
import ResourcesUnavailable from "@/utils/resources/unavailable";

interface UiMessageSanctionedProps {
  subject?: string;
}

export default function UiMessageSanctioned({ subject }: UiMessageSanctionedProps) {
  return (
    <div className="restricted">
      <div className="restricted-logo">
        <ResourcesUnavailable />
      </div>
      <div className="flex w-full flex-col space-y-4 p-6">
        {subject ? (
          <SupText variant="subtitle1">{subject}</SupText>
        ) : (
          <SupText variant="subtitle1">
            You are accessing this interface from a restricted region. This interface is not available to residents of Belarus, the Central African Republic, the Democratic
            Republic of Congo, the Democratic People’s Republic of Korea, the Crimea, Luhansk, and Donetsk region of Ukraine, Cuba, Iran, Libya, Somalia, Sudan, South Sudan, Syria,
            Yemen, and Zimbabwe or any other jurisdiction in which accessing or using the Superform dApp is prohibited (“Prohibited Jurisdictions”).
          </SupText>
        )}
        <AdapterLinkButton
          buttonProps={{
            fluid: true,
          }}
          target="_blank"
          href="https://superformlabs.org/terms-of-service"
        >
          Please see our Terms of Service for more information
        </AdapterLinkButton>
      </div>
    </div>
  );
}
